/* eslint-disable */
import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ThemeModeService } from "@metronic/partials/layout/theme-mode-switcher/theme-mode.service";
import { TranslationService } from "@modules/i18n";
import { locale as eng } from "./modules/i18n/vocabs/eng";
import { locale as ru } from "./modules/i18n/vocabs/ru";
import { locale as uz } from "./modules/i18n/vocabs/uz";
import { locale as uzcrl } from "./modules/i18n/vocabs/uzcrl";
import { DatePipe } from "@angular/common";
// import { AppUpdateService } from "@core/services/app-update.service";

@Component({
  selector: "body[root]",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet],
  providers: [DatePipe],
})
export class AppComponent implements OnInit {
  constructor(
    private _translationService: TranslationService,
    private _modeService: ThemeModeService
    // private appUpdate: AppUpdateService
  ) {
    this._translationService.loadTranslations(uz, uzcrl, ru, eng);
  }

  async ngOnInit() {
    this._modeService.init();

    const oldSite = sessionStorage.getItem("oldSite");
    if (!oldSite) {
      window.location.reload();
      sessionStorage.setItem("oldSite", "false");
    }
  }
}
